'use strict'

var warn = require('../../notices').warn
var request = require('../../request');
var formtourlsearchparams = require('../../formtourlsearchparams')

function retriveTranslatedText(form) {

  request.post(form.action, formtourlsearchparams(form))
    .then(JSON.parse)
    .then(function(res) {
      var selfTransSpinner = document.getElementById('selfTranslatedSpinner')
      var selfTrans = document.querySelector('[data-self-translated-text]')
      var whoTrans = document.querySelector('[data-who-translated-text]')

      if (selfTrans) {
        var selfHTML = document.createRange().createContextualFragment(res.self_translation)
        selfTrans.appendChild(selfHTML);
        selfTrans.hidden = false;
      }

      if (whoTrans) {
        var whoHTML = document.createRange().createContextualFragment(res.who_translation)
        whoTrans.appendChild(whoHTML);
        whoTrans.hidden = false;
      }

      if (selfTransSpinner)
        selfTransSpinner.hidden = true;
    })
    .catch(function(res){
      warn()
    })
}

function init() {
  document.forms.translateTextRequired && retriveTranslatedText(document.forms.translateTextRequired)
}
window.addEventListener('DOMContentLoaded', init)